import {gql} from '@apollo/client';
import {Button, Col, Row} from 'antd';
import {useCallback} from 'react';
import {CSSTransition, TransitionGroup} from 'react-transition-group';
import {Art} from 'src/components';
import {useMonaTokensContract} from 'src/hooks';
import Address from './Address';
import MasonryGrid from './MasonryGrid';
import {ArtFragment} from './__generated__/ArtFragment';
import styles from './Arts.module.scss';

export const GqlArtFragment = gql`
  fragment ArtFragment on Art {
    id
    uri
    realArtist
    title
    mintedAt
    imageUri
    mintedAt
    artist {
      id
      name
      uri # Needed for metadata augmentation
    }
    owner {
      id
    }
  }
`;

type ArtsProps = {
  arts?: ArtFragment[];
  showExtraInfo?: boolean;
  maxColumns?: number;
};

export default function Arts({arts, maxColumns, showExtraInfo = true}: ArtsProps) {
  const monaTokens = useMonaTokensContract();

  const handleRefreshMetadata = useCallback(
    (id: string) => {
      return monaTokens.refreshMetadata([id]);
    },
    [monaTokens],
  );

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        {arts && (
          <TransitionGroup enter appear={true} component={null}>
            <MasonryGrid maxColumns={maxColumns}>
              {arts.map((a) => {
                const ownerId = a.owner?.id;
                return (
                  <CSSTransition
                    key={a.id}
                    component={null}
                    classNames={{
                      enterActive: 'animate__animated animate__lightSpeedInLeft',
                      exitActive: 'animate__animated animate__lightSpeedOutRight',
                    }}
                    timeout={900}>
                    <div>
                      <Art {...a}>
                        {showExtraInfo && (
                          <div className={styles.creatorOwner}>
                            <div>Creator: {a.artist.name}</div>
                            {ownerId && (
                              <div>
                                Owner: <Address address={ownerId} size='small' isLinked />
                              </div>
                            )}
                          </div>
                        )}
                      </Art>

                      {!a.imageUri && (
                        <>
                          <br />
                          <Button size='small' onClick={() => handleRefreshMetadata(a.id)}>
                            Refresh Metadata
                          </Button>
                        </>
                      )}
                    </div>
                  </CSSTransition>
                );
              })}
            </MasonryGrid>
          </TransitionGroup>
        )}
      </Col>
    </Row>
  );
}
